const endOfLifeNotification = "On April 24th, the legacy Cato Management Application will be end-of-life and you will only be able to use the new Interface.We recommend that you start using it now and become familiar with the new screens and features."

function MainController($scope, $controller, $location,  $timeout, $rootScope, $state, $q, GeneralUtilsService, $filter, DateRangeService, $transitions, UserContextService, IntervalService) {
    $controller('BaseController', { $scope: $scope, $location: $location, $timeout: $timeout, $state: $state, $rootScope: $rootScope, $q: $q, GeneralUtilsService: GeneralUtilsService, $transitions: $transitions, UserContextService: UserContextService, IntervalService:IntervalService});

    var revliteProgressCounter = 0;
    var cancel = false;
    var lastNotificationUpdate,
        firstNotificationsRequest = true;
    const SYSTEM_ACCOUNT_ID = 1;
    var stateTimeout;

    $rootScope.dateRange = {};
    var defaultTime;
    $scope.openMenu = [];
    $rootScope.menuClosed = false;
    $scope.datepickerOptions = {
        reload: false,
        single: false,
    };

    $scope.systemLinksOpen = false;
    $scope.newSystemLink = {name: '', url: ''};
    $scope.showSystemLinks = isSystemLogin;
    $scope.buildInfo = {branch: branch === '' ? null : branch, build: buildNumber === '' ? null : buildNumber};
    const DISMISS_NEW_UI_MODAL_KEY = "DismissNFEModal";
    let dismissNFEModal = window.localStorage.getItem(DISMISS_NEW_UI_MODAL_KEY) && window.localStorage.getItem(DISMISS_NEW_UI_MODAL_KEY) === "true";
    $scope.dismissNFEModal = false;

    function savePreferenceToLocalStorage() {
        if ($scope.dismissNFEModal) {
            window.localStorage.setItem(DISMISS_NEW_UI_MODAL_KEY, true);
            dismissNFEModal = true;
        }
    }

    $scope.switchToNewUi = function () {
        $scope.dismissNFEModal = true;
        savePreferenceToLocalStorage();
        $rootScope.saveChoiceAndJumpToAmazingUi();
    }

    $scope.closeModal = function () {
        $scope.dismissNFEModal = true;
        savePreferenceToLocalStorage();
        $rootScope.closePopup("new-ui-switch-modal");
    }

    function refreshPageTitle() {
        document.title = $scope.accountName + ' - ' + $scope.title;
    }

    function updateBucketDuration(newBucketDuration) {
        var $bucketDuration = $('#bucketduration-tooltip');
        $bucketDuration.attr('title', 'Bucket Duration: ' + $filter('duration')(newBucketDuration, true));
        $timeout(function () {
            $bucketDuration.tooltip('destroy');
            $bucketDuration.tooltip();
        }, 0, false);
    }

    function defaultDateRange (params) {
        var tempStart;
        var tempEnd;
        let num, unit;
        let isRelativeTimeRange = false;
        if (params.start) {
            [num, unit] = DateRangeService.parseRangeTextStart(params.start);
            if (num !== null && unit !== null) {
                isRelativeTimeRange = true;
                tempStart = new Date();
                if (unit === 'day') {
                    tempStart.setDate(tempStart.getDate()-num);
                    tempStart.setHours(0,0,0, 0);
                }
                else if (unit === 'hour') {
                    tempStart.setHours(tempStart.getHours()-num);
                }
                tempStart = tempStart.getTime();
            }
            else {
                tempStart = parseInt(params.start, 10);
            }
        }
        if (params.end) {
            if (isRelativeTimeRange || params.end === "now") {
                if (unit !== null) {
                    if (unit === 'day') {
                        tempEnd = DateRangeService.getEndOfDay().getTime();
                    }
                    else if (unit === 'hour') {
                        tempEnd = Date.now();
                    }
                }
            }
            else {
                tempEnd = parseInt(params.end, 10);
            }
        }

        if (!tempStart || !tempEnd) {
            defaultTime = DateRangeService.getEndOfDay();

            tempStart = tempStart || (((moment(defaultTime).subtract('2', 'days').unix() + 1) * 1000)); // last day(this one and yesterday)
            // (default time span)
            tempEnd = tempEnd || defaultTime.getTime();
        }

        $rootScope.dateRange.start = tempStart;
        $rootScope.dateRange.end = tempEnd;
        DateRangeService.initCurrent(tempStart, tempEnd);
        if (!DateRangeService.updateBucketDuration) {
            DateRangeService.updateBucketDuration = updateBucketDuration;
        }
    }

    $rootScope.sites = [];
    $scope.isHomePage = true;
    $scope.badGateway = false;
    $scope.nav = nav;
    $scope.role = 'regular';
    $scope.meIsCurrent = true;
    $scope.location = $location;


    $scope.clearFilters = function () {
        $scope.tabFilter = null;
        $scope.filterStr = null;
        /* $rootScope.start = null;
        $rootScope.end = null;*/
    };

    $scope.removeFilter = function () {
        if ($scope.nav.currPage === 'monitoring') {
            var initialURL = $location.absUrl();

            $scope.tabFilter = null;
            $scope.filterStr = null;
            removeParam($location, 'filter');
            if (initialURL === $location.absUrl()) {
                window.location.reload();
            }
        } else {
            $scope.tabFilter = null;
            $scope.filterStr = null;
            removeParam($location, 'filter');
        }
    };
    // End of settings


    function goToStateDates() {
        DateRangeService.zoomTo($rootScope.dateRange.start, $rootScope.dateRange.end, $rootScope.dateRange.bucketDuration);
    }

    function tagsInTagsList(tagsList) {
        var found = false;
        tagsList.forEach(function (tag) {
            if ($rootScope.tags.indexOf(tag) >= 0) {
                found = true;
            }
        });

        return found;
    }

    function setFilters(filterStr) {
        if (filterStr) {
            $scope.filterStr = filterStr;
            $scope.tabFilter = angular.fromJson(filterStr);
            $scope.selectedFilter = $scope.tabFilter;
        } else {
            $scope.filterStr = null;
            $scope.tabFilter = null;
            $scope.selectedFilter = null;
        }
    }


    $scope.$watch('dateRange', function (newValue, oldValue) {
        if (newValue && $state.current.name) {
            if (newValue.bucketDuration) {
                updateBucketDuration(newValue.bucketDuration)
            }

            if (newValue.start !== oldValue.start || newValue.end !== oldValue.end) {
                goToStateDates();
            }
        }
    }, true);

    $rootScope.$watch('lastUpdatedMiliseconds', function () {
        $scope.getLastUpdated();
    });

    $rootScope.$watch('menuClosed', function () {
        $scope.menuClosed = $rootScope.menuClosed;
    });

    $scope.revliteStatusTimeoutInMili = 3000;
    $scope.revliteStatusMaxTimeoutInMili = 4000;

    IntervalService.dynamicInterval(checkServerMessages, $scope.$id, 'mainCtrlServerMessages', false);

    // return if this page should be visible to the current account
    $scope.showPage = function (page) {
        let showPageByTags = isPageAvailableByTags(page);
        let showPageByAttributes = isPageAvailableByRootAttributes(page);

        // returning if page is visible based on role and tags restrictions
        return (!page.roles || page.roles.indexOf($scope.role) !== -1) && showPageByTags && showPageByAttributes;
    };

    function isPageAvailableByIndicator(allowItem, blockItem, predicate) {
        // if page has an allowItem restrictions it has to have an allowItem that satisfies the predicate (or is the item that satisfies the predicate )
        // if page has a blockItem restrictions it can't to have a blockItem that satisfies the predicate (or is the item that satisfies the predicate )
        let show = true;
         if (allowItem || blockItem) {
            if (predicate) {
                if (allowItem) {
                    show = false;
                    if (typeof allowItem === 'string'  && predicate(allowItem)) {
                        show = true;
                    } else if (allowItem instanceof Array && allowItem.some(tag => predicate(tag))){
                        show = true;
                    }
                }
                if (blockItem) {
                    if (typeof blockItem === 'string' && predicate(blockItem)) {
                        show = false;
                    } else if (blockItem instanceof Array && blockItem.some(tag => predicate(tag))){
                        show = false;
                    }
                }
            } else {
                show = false;
            }
        }

        return show;
    }

    function isPageAvailableByTags (page) {
        return isPageAvailableByIndicator(page.tags, page.notTags, (tag)=>{  return $rootScope && $rootScope.tags && $rootScope.tags.includes(tag)});
    }

    function isPageAvailableByRootAttributes (page) {
         return isPageAvailableByIndicator(page.requireAttribute, page.notAttribute, (item) => { return $rootScope && $rootScope[item]});
     }

    $scope.navigateToPage = function (page) {
        var newState = page.state;
        // there are sub pages - get state from first active page
        if ($scope.nav[page.id]) {
            var activeSubPages = $scope.nav[page.id].filter($scope.showPage);
            if (activeSubPages.length > 0) {
                var firstIndex = $scope.nav[page.id].indexOf(activeSubPages[0]);
                newState = $scope.nav[page.id][firstIndex].state;
            }
        }
        var stateParams = {};
        if ($scope.filterStr) {
            stateParams.filter = $scope.filterStr || '';
        }
        $state.go(newState, stateParams);
    };

    /**
    * clearing account data details
    */
    function clearAccountData(){
        $rootScope.tags = null;
        $rootScope.externalVlan = null;
        $rootScope.internalVlan = null;
        $rootScope.userAwareness = null;
        $rootScope.accountType = null;
        $rootScope.useNewFW = null;
        $scope.accountName = null;
        $scope.accountProductionType = null;
        $scope.dhcpRelayEnabled = null;
    }

    $scope.loadAccount = function (state, params, checkNotifications) {
        clearAccountData();
        store.fetch({
            path: '/accountData?accountId=' + (params.accountId ? params.accountId : ''),
            success: function (data) {
                if (cancel) {
                    return;
                }

                if (data.isParent) {
                    $scope.role = 'reseller';
                } else {
                    $scope.role = 'regular';
                }
                $scope.meIsCurrent = (data.meId === data.id);

                if (state.url === '' || state.url === '/') {
                    if (data.meIsParent) {
                        $rootScope.userEdited = false;
                        $rootScope.progressDone = false;
                        revliteProgressCounter = 0;
                        $scope.clearFilters();
                    }
                    $state.go(data.meIsParent ? 'app.accounts' : 'app.topology', { accountId: data.meId }, {
                        location: 'replace',
                        inherit: !data.meIsParent,
                    });
                }

                $rootScope.isSystemAccount = data.id === SYSTEM_ACCOUNT_ID;
                $rootScope.tags = data.tags;
                $rootScope.useNewFW = data.useNewFW;
                $rootScope.externalVlan = data.externalVlan;
                $rootScope.internalVlan = data.internalVlan;
                $rootScope.userAwareness = data.userAwareness;
                $rootScope.accountType = data.accountType;
                $rootScope.fqdn = data.fqdn;
                $scope.accountName = data.name;
                refreshPageTitle();
                $scope.accountProductionType = data.productionType;
                $scope.dhcpRelayEnabled = data.dhcpRelayEnabled;
                checkServerMessages(params.accountId);
                $rootScope.$apply();
            },
        });
    };

    $scope.setNotifications = function (notifications) {
        $scope.notifications = $scope.notifications || [];

        var newNotifications = [];
        notifications.forEach(function(noti) {
            var i,
                creationDate = new Date(noti.creationDate);
            noti.creationDate = new Date(Date.UTC(creationDate.getFullYear(), creationDate.getMonth(), creationDate.getDate(), creationDate.getHours(), creationDate.getMinutes(), creationDate.getSeconds()));
            for (i = 0;$scope.notifications[i]; i++) {
                if ($scope.notifications[i].id === noti.id) {
                    break;
                }
            }
            if (i === $scope.notifications.length) {
                newNotifications.unshift(noti);
            }
        });

        $timeout(function() {
            $scope.notifications = newNotifications.concat($scope.notifications);
            //$scope.notifications = _.unionBy($scope.notifications || [], notifications, function (noti) { return  (noti.id) });
            $scope.$root.setNotificationsSeverity();
            $timeout(function () {
                $scope.$root.updateScroll('.notifications-drawer .nano');
            }, 0, false);
        }, 1);
    };

    $scope.$root.setNotificationsSeverity = function () {
        var severities = {
            LOW: 0,
            MEDIUM: 1,
            HIGH: 2,
            CRITICAL: 3,
        };
        var severity = 'LOW';

        if ($scope.notifications) {
            $scope.notifications.forEach(function (noti) {
                if (severities[noti.severity] > severities[severity]) {
                    severity = noti.severity;
                }
            });
        }

        $scope.notificationsSeverity = severity;
    };

    var checkPageNavigation = function (page, subPage, current) {
        if (subPage.state && (subPage.state === current.name || subPage.state === current.menu)) {
            $scope.nav.currPage = page;
            $scope.nav.currPageTitle = _.find($scope.nav.topPages, { id: $scope.nav.currPage }).name;
            $scope.nav.currSubPage = subPage;
            $scope.$root.dividedInner = false;
            return true;
        }
        return false;
    };

    $transitions.onStart({}, function(transition) {
        var toState = transition.to();
        var toParams = transition.params('to');
        var fromState = transition.from();
        var fromParams = transition.params('from');

        if (toState.redirectTo) {
            transition.abort();
            $state.go(toState.redirectTo, toParams);
        }
        if (fromState && fromState.workProtect && $rootScope.hasChanges && $rootScope.hasChanges()) {
            var message = "You have unsaved changes. Press 'OK' to leave this page and discard your changes or press 'Cancel' to stay on this page.";

            $rootScope.confirm(
                message,
                function () {
                    $rootScope.hasChanges = function () {
                        return false;
                    };
                    $state.go(toState, toParams);
                }
            );
            transition.abort();
        } else {
            if (toState.url === '' || toState.url === '/') {
                transition.abort();
                $scope.loadAccount(toState, toParams, checkNotifications);
            } else {
                defaultDateRange(toParams);
            }
            var checkNotifications = false;

            if (fromParams.accountId !== toParams.accountId) {
                $scope.notifications = [];
                firstNotificationsRequest = true;
                checkNotifications = true;
                $scope.loadAccount(toState, toParams, checkNotifications);
            }

            $scope.$root.closeAllPopups();

            if (!toState.dontClearAmCharts && typeof AmCharts !== 'undefined' && AmCharts && AmCharts.charts) {
                AmCharts.charts.forEach(function (chart) {
                    chart.clear();
                    chart = null;
                });

                AmCharts.charts = [];
            }

            // console.log("unbinding");
            var $mainInner = $('#main-inner');
            $mainInner.find('.nano').nanoScroller({ destroy: true });
            $mainInner.find('[data-toggle="tooltip"]').tooltip('destroy');
            $mainInner.off().find('*').off();


            // clearing stored requests
            store.clearRequests();
        }
    });

    var showingLowResMessage;

    function checkMinResolution() {
        if ($(window).width() < 1280) {
            if (!window.sessionStorage.getItem('RememberLowRes') && !window.localStorage.getItem('RememberLowRes')) {
                if (!$scope.$root.openedPopup && !showingLowResMessage) {
                    showingLowResMessage = true;
                    $scope.$root.alert(
                        'The optimal resolutions for viewing this application are 1280x720 and above.',
                        null,
                        function () {
                            if ($scope.$root.confirmData.checkboxModel) {
                                window.localStorage.setItem('RememberLowRes', true);
                            } else {
                                window.sessionStorage.setItem('RememberLowRes', true);
                            }
                        },
                        'Never Show Again'
                    );
                }
            }
        }
    }

    $transitions.onFinish({}, function(transition) {
        $rootScope.hasChanges = null;

        // find current filter
        var toParams = transition.params('to');
        setFilters(toParams.filter);
    });

    $transitions.onSuccess({}, function(transition) {
        var current = transition.to();
        var toParams = transition.params('to');

        $rootScope.clearLoader();
        checkHideGlobalNotification(false);
        $scope.datepickerOptions.reload = true;
        $scope.params = toParams;
        $scope.$root.errorsNum = 0;
        $scope.nav.show = (!current.top && location.hash !== '' && location.hash !== '/');

        $scope.$root.currentCategory = null; // clear current category
        $scope.$root.globalNotification = null;
        $scope.timeRange = current.timeRange;
        $scope.showFilter = current.filter;
        $scope.lastUpdated = null;

        // setRealtimeDatepicker(current);

        $scope.title = current.title;
        refreshPageTitle();

        $scope.location = $location;
        $rootScope.accountId = toParams.accountId;

        var found = false;
        for (var key in $scope.nav.topPages) {
            if (found) break;
            var pageId = $scope.nav.topPages[key].id;
            if (!$scope.nav[pageId]) {
                if (checkPageNavigation(pageId, $scope.nav.topPages[key], current)) {
                    break;
                }
            } else {
                for (var key1 in $scope.nav[pageId]) {
                    var subPage = $scope.nav[pageId][key1];
                    if (checkPageNavigation(pageId, subPage, current)) {
                        found = true;
                        break;
                    }
                }
            }
        }
    });

    /* function setRealtimeDatepicker(current) {
        var rtRangeLi = $('.daterangepicker .ranges ul li:first-of-type');
        if (rtRangeLi.text() === 'Realtime') {
            if (current.rt) {
                rtRangeLi.show();
            } else {
                rtRangeLi.hide();
            }
        }
    }*/

    $rootScope.userEdited = false;
    $scope.progressDone = false;
    $scope.progress = 0;
    $scope.progressMessage = '';

    function openNewUiSwitchNotification() {
        // workaround, multiple render flow cause init to trigger open popup... use window.flag
        if(window.popupUiSwitchNotify) {
            clearTimeout(window.popupUiSwitchNotify);
        }
        // Close any prev modals / backdrop-fades (on-resize)
        $rootScope.closePopup("new-ui-switch-modal");
        window.popupUiSwitchNotify = setTimeout(() => {
            if (!dismissNFEModal && shouldShowFNEModal) {
                window.popupUiSwitchInProgress = true;
                $rootScope.openPopup("new-ui-switch-modal");
                $scope.dismissNFEModal = true;
                savePreferenceToLocalStorage();
            }
        }, 500);
    }

    $scope.init = function () {
        var $window = $(window);
        $timeout(function () {
            $('#navbar-left').height($window.height() - 60);
            if ($window.width() < 1300) {
                $rootScope.menuClosed = true;
                $('body').addClass('miniMenu');
                checkMinResolution();
            }
            $('#time-range-wrapper').find('[data-toggle="tooltip"]').tooltip();

            openNewUiSwitchNotification();
        }, 1, false);

        $timeout(function() {
            if (typeof zE !== "undefined") {
                zE(function() {
                    zE.identify({
                        name: $scope.adminName.first + ' ' + $scope.adminName.last,
                        email: UserContextService.getEmail()
                    });
                    zE.activateIpm();
                });

                function hideZdIcon() {
                    var $launcher = $('#launcher');
                    if ($launcher.length === 0 || !$launcher.hasClass('zEWidget-launcher--active')) {
                        window.setTimeout(hideZdIcon, 100);
                    } else {
                        $launcher.contents().find('head').append($('\
                            <style> \
                            #Embed .Icon { display:none !important; } \
                            #Embed .Icon.Icon--chat { display:inline-block !important; } \
                            </style> \
                        '));
                    }
                }

                hideZdIcon();
            }
        }, 150, false);
    };

    $(function () {
        $scope.pageReady = true;
        $scope.init();

        $(window).resize(function () {
            $scope.init();
        });

        var $revliteTooltip = $('#revliteProgress');
        if ($revliteTooltip.tooltip) {
            $revliteTooltip.tooltip();
        }
    });

    function checkServerMessages(accountId) {
        accountId = accountId || $state.params.accountId;
        if (!accountId) {
            return;
        }
        store.fetch({
            // using idOfAccount instead of account id in order to skip heavy validations in authorization plugin
            path: '/getServerMessages?idOfAccount=' + accountId + '&creationDate=' + (firstNotificationsRequest? null : lastNotificationUpdate),
            success: function (data) {
                if (accountId !== $state.params.accountId) {
                    return;
                }
                lastNotificationUpdate = data.timestamp; // used to fetch only notifications that were created after our previous request
                firstNotificationsRequest = false;

                if (data) {
                    // set or remove global message (server message to all accounts)
                    if (data.serverMessage && data.serverMessage !== '') {
                        if (!$scope.$root.globalNotification || $scope.$root.globalNotification.message !== data.serverMessage) {
                            $scope.$root.globalNotification = { type: 'info', message: data.serverMessage, title: data.serverMessage, sticky: true, serverMessage: true };
                            $scope.$root.$emit('$saveFail');
                        }
                    } else {
                        showEndOfLifeMessage();
                    }
                    $scope.setNotifications(data.notifications || []);
                } else {
                    showEndOfLifeMessage();
                }
            }
        });
    }

    function showEndOfLifeMessage() {
        /**disable end-of-life message*/
        let showEndOfLifeMessage = false;

        if (showEndOfLifeMessage) {
            if (!shouldShowFNEModal || $scope.$root.endOfLifeShown) {
                checkHideGlobalNotification(true);
            }
            else {
                $scope.$root.globalNotification = {
                    type: 'error',
                    message: endOfLifeNotification,
                    title: "end-of-life",
                    sticky: true,
                    serverMessage: true
                };
                $scope.$root.$emit('$saveFail');
            }
        }
    }

    function checkHideGlobalNotification(hideServerMessage) {
        if ($scope.$root.globalNotification) {
            if (hideServerMessage) {
                if ($scope.$root.globalNotification.serverMessage) {
                    $scope.$root.globalNotification = null;
                    $scope.$root.$emit('$hideNotification');
                }
            } else {
                if (!$scope.$root.globalNotification.serverMessage) {
                    $scope.$root.globalNotification = null;
                    $scope.$root.$emit('$hideNotification');
                }
            }
        }
    }


    function sessionExpired() {
        var hash = window.location.hash;
        if (hash) {
            hash = decodeURIComponent(hash).replace('&amp;', '&');
            window.location = "/login" + hash;
        } else {
            window.location = "/login";
        }
    }

    var loader = {
        $el: $('#loading-wrapper'),
        shown: false,
        requests: {},
        add: function (requestId) {
            if (!requestId) {
                this.show();
                return;
            }

            if (this.requests[requestId]) {
                this.requests[requestId] = true;
            }

            this.show();
        },
        remove: function (requestId) {
            if (!requestId) {
                this.hide();
                return;
            }

            if (this.requests[requestId]) {
                delete this.requests[requestId];
            }
            if (Object.keys(this.requests).length === 0) {
                this.hide();
            }
        },
        clear: function () {
            this.requests = {};
            this.hide();
        },
        show: function () {
            if (this.$el.css('opacity') < 1) {
                this.$el.stop();
            }
            this.shown = true;
            this.$el.css('display', 'block').css('opacity', 1);
        },
        hide: function () {
            if (this.$el.css('opacity') < 1) {
                this.$el.stop();
            }
            this.shown = false;
            this.$el.fadeOut(100).css('opacity', 1);
        },
    };

    store.loader = function (show, requestId) {
        if (show === 'show') {
            loader.add(requestId);
        } else {
            loader.remove(requestId);
        }
    };

    $rootScope.clearLoader = function () {
        loader.clear();
    };

    $rootScope.showLoader = function (requestId) {
        loader.add(requestId);
    };

    $rootScope.hideLoader = function (requestId) {
        loader.remove(requestId);
    };

    store.onExpireSession = function () {
        sessionExpired();
    };

    store.onBadGateway = function (rt) {
        /*if (rt) {
            if (!$scope.badGateway) {
                $scope.$root.globalNotification = { type: 'error', message: 'Temporarily Offline', title: 'Temporarily Offline', sticky: true };
                $scope.$root.$emit('$saveFail');
                $scope.badGateway = true;
            }
        } else {
            window.location = '/login';
        }*/
    };

    store.onBadGatewayEnd = function () {
        if ($scope.badGateway) {
            $scope.$root.$emit('$hideNotification');
            $scope.badGateway = false;
            sessionExpired();
        }
    };

    $scope.getLastUpdated = function () {
        if ($rootScope.lastUpdatedMiliseconds) {
            $scope.lastUpdated = moment.duration($rootScope.lastUpdatedMiliseconds).seconds();
        }
    };

    $scope.toggleMenu = function () {
        $rootScope.menuClosed = !$rootScope.menuClosed;
        $scope.$broadcast('sideMenuChange');
        $('body').toggleClass('miniMenu');
    };

    $scope.getDocumentationLink = function () {
        return 'getDocumentationPage?route=' + getRoute();
    };

    function getRoute() {
        return formatRouteNameToDocFriendly($scope.nav.currPage + ($scope.nav.currPage == $scope.nav.currSubPage.id ? '' : (',' + $scope.nav.currSubPage.id)) +
            ($scope.$root.currentCategory? (',' + $scope.$root.currentCategory) : '') + ($scope.$root.currentSubCategory ? (',' + $scope.$root.currentSubCategory) : ''));
    }

    function formatRouteNameToDocFriendly(name) {
        return name ? name.replace(/\(|\)|\./g, "") : '';
    }

    $scope.toggleSystemLinks = function () {
        getSystemLinks();
        $scope.systemLinksOpen = !$scope.systemLinksOpen;
        $scope.wikiSearch = 'https://catonetworks.atlassian.net/wiki/dosearchsite.action?queryString=' + $scope.nav.currPageTitle  + ($scope.nav.currPage == $scope.nav.currSubPage.id ? '' : (' ' + ($filter('capitalize')($scope.nav.currSubPage.name)))) + ($scope.$root.currentCategory? (' ' + ($filter('capitalize')($scope.$root.currentCategory))) : '');
    };

    function getSystemLinks() {
        $scope.systemLinks = [];
        store.fetch({
            path: '/getSystemLinks?route=' + getRoute(),
            success: function(data) {
                $scope.systemLinks = data;
                $scope.$digest();
            }
        });
    }

    $scope.addSystemLink = function() {
        store.action({
            path: '/addSystemLinks?route=' + encodeURIComponent(getRoute()) + '&name=' + encodeURIComponent($scope.newSystemLink.name) + '&url=' + encodeURIComponent($scope.newSystemLink.url),
            success: function() {
                $scope.newSystemLink.name = '';
                $scope.newSystemLink.url = '';

                getSystemLinks();
            }
        });
    };

    $scope.clearLocalZoom = function() {
        DateRangeService.clearLocalZoom();
    };

    $scope.rangeBack = function() {
        DateRangeService.goBack();
    };

    $scope.rangeForward = function() {
        DateRangeService.goForward();
    };

    $scope.rangeHistory = function() {
        DateRangeService.goHistory();
    };

    $scope.hasDateRangeHistory = function() {
        return DateRangeService.hasHistory();
    };

    $scope.hasRangeForward = function() {
        return DateRangeService.hasJumpForward();
    };

    $scope.showAccountSelector = function() {
        if ($scope.pressingShift) {
            $scope.showAccountsSelector = true;

            if (!$scope.accountsListConfig.items || $scope.accountsListConfig.items.length === 0) {
                $scope.refreshAccountList = new Date().getTime();
            }
        }
    };

    $scope.accountsListConfig = {
        defer: true,
        titleSearch: 'Accounts',
        dataURL : function(){
            return "/accounts?&viewType=SimpleList&enablePaging=true";
        },
        pageSize:15,
        afterUpdate: function(){
            if($scope.$root){
                $timeout(function () {
                    $scope.$root.updateScroll('.accounts-list-dropdown .nano');
                }, 0, false);
            }
        },
        height: 380,
        noAutoCheckboxSelect: true,
        noAutoSelect: true,
        mode: 'list',
        fields : [
            {"label":"Name","path":"name"},
            {"label":"Creation Date","path":"creationDate"},
            {"label":"Last Modified","path":"lastModified"},
        ],
        hideCheckboxes: true,
        onSelect: function(index) {
            var accountId = this.items[index].id;
            $state.go($state.current.name, { accountId: accountId, filter: null});
        },
    };

    $(document).on('keydown', checkKeyDown);
    $(document).on('keyup', checkKeyUp);

    $scope.pressingShift = false;
    function checkKeyDown(e) {
        if (e.which === 16) {
            $timeout(function() {
                $scope.pressingShift = true;
            }, 0);
        }
    }
    function checkKeyUp(e) {
        if(e.which === 16) {
            $timeout(function() {
                $scope.pressingShift = false;
            }, 0);
        }
    }

    $('body').click(checkDropdown);

    function checkDropdown(evt) {
        if ($scope.systemLinksOpen && $(evt.target).parents('.systemlinks-dropdown').length == 0) {
            $scope.systemLinksOpen = false;
            $scope.$digest();
        }
    }

    $scope.$on('$destroy', function () {
        $('body').off('click', checkDropdown);
        $(document).off('keydown', checkKeyDown);
        $(document).off('keyup', checkKeyUp);
        if (stateTimeout) {
            $timeout.cancel(stateTimeout);
        }
        $(window).off('resize', $scope.init);
    });

}


